var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-list-cell',{staticClass:"language",attrs:{"format":_vm.format,"type":"stat"}},[_c('div',{staticClass:"language-band",class:( _obj = {}, _obj[_vm.bandClass] = true, _obj )},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }